import { render, staticRenderFns } from "./RecommendedCoursesInstitutions.html?vue&type=template&id=19d9fa9c&scoped=true&"
import script from "./RecommendedCoursesInstitutions.vue?vue&type=script&lang=js&"
export * from "./RecommendedCoursesInstitutions.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedCoursesInstitutions.scss?vue&type=style&index=0&id=19d9fa9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d9fa9c",
  null
  
)

export default component.exports